/* eslint-disable no-underscore-dangle */
/* eslint-disable @typescript-eslint/member-ordering */
/* eslint-disable @typescript-eslint/quotes */
import { AfterViewInit, Component, OnInit, ViewChild } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatPaginator } from "@angular/material/paginator";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatTableDataSource } from "@angular/material/table";
import { CategoryService } from "../category/category.service";
import { AddEditSubCategoryComponent } from "./add-edit-sub-category/add-edit-sub-category.component";
import { SubCategoryService } from "./sub-category.service";
const COLS = [
  { value: "sucNameEng", lowercaseValue: "sucNameEng", displayName: "Category Name (English)" },
  { value: "sucNameMar", lowercaseValue: "sucNameMar", displayName: "Category Name (मराठी)" },
];

export interface PeriodicElement {
  sucNameEng: string;
  sucNameMar: string;
}

const ELEMENT_DATA: PeriodicElement[] = [];

@Component({
  selector: "app-sub-category",
  templateUrl: "./sub-category.component.html",
  styleUrls: ["./sub-category.component.scss"],
})
export class SubCategoryComponent implements OnInit, AfterViewInit {
  displayedCols = COLS;
  allCols = COLS;
  displayedColumns: any[];
  dataSource = new MatTableDataSource(ELEMENT_DATA);

  constructor(
    public dialog: MatDialog,
    private categoryService: CategoryService,
    private subCategoryService: SubCategoryService,
    private _snackBar: MatSnackBar
  ) {}

  selectedCategory: any = null;
  categories: any[] = [];

  @ViewChild(MatPaginator) paginator: MatPaginator;

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }

  ngOnInit(): void {
    this.displayedCols = [
      { value: "sucNameEng", lowercaseValue: "sucNameEng", displayName: "Name" },
      { value: "sucNameMar", lowercaseValue: "sucNameMar", displayName: "Weight" },
    ];

    this.displayedColumns = this.displayedCols.map((col) => col.value);
    this.getCategories();
  }

  async getCategories() {
    this.categories = [];
    const response: any = await this.categoryService.getCategories();
    console.log(response);
    if (!response.error) {
      if (response.length > 0) {
        this.categories = response;
      } else {
        this.warningToast();
      }
    } else {
      this.errorToast();
    }
  }

  async getSubCategories() {
    this.dataSource = new MatTableDataSource();
    // const response: any = await this.subCategoryService.getSubCategories(this.selectedCategory.pkCatid);
    // console.log(response);
    // if (!response.error) {
    //   if (response.length > 0) {
    //     this.dataSource = new MatTableDataSource(response);
    //     this.dataSource.paginator = this.paginator;
    //   } else {
    //     this.warningToast();
    //   }
    // } else {
    //   this.errorToast();
    // }
    await this.subCategoryService.getSubCategoriesV1(this.selectedCategory.pkCatid).subscribe((response: any) => {
      console.log(response);
      if (!response.error) {
        if (response.length > 0) {
          this.dataSource = new MatTableDataSource(response);
          this.dataSource.paginator = this.paginator;
        } else {
          this.warningToast();
        }
      } else {
        this.errorToast();
      }
    });
  }

  addNewSubCategory() {
    const dialogRef = this.dialog.open(AddEditSubCategoryComponent, {
      panelClass: ["custom-popup"],
      width: "50%",
      disableClose: true,
      data: ["New"],
      autoFocus: false,
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);
      if (result == "success") {
        this.getSubCategories();
      }
    });
  }

  editSubCategory(data: any) {
    console.log(data);
    const dialogRef = this.dialog.open(AddEditSubCategoryComponent, {
      panelClass: ["custom-popup"],
      width: "50%",
      disableClose: true,
      data: ["Edit", data],
      autoFocus: false,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result == "success") {
        this.getSubCategories();
      }
    });
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  async warningToast() {
    await this._snackBar.open("No data available for the selection.", "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "warning-toast",
      duration: 3 * 1000,
    });
  }

  async errorToast() {
    await this._snackBar.open("Oops, something went wrong, please try after sometime.", "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "error-toast",
      duration: 3 * 1000,
    });
  }
}
